import angular from 'angular';
import booksMenu from '../../menu/Menu';

export default angular
  .module('consolidatedAcctsReport', [booksMenu])
  .controller('consolidatedAcctsReportController', consolidatedAcctsReportController)
  .name;
  
/* @ngInject */ function consolidatedAcctsReportController($scope, BooksSvc, $q, BusyScreen, Session) {
  /*---------------------*/
  /* Sets default values */
  /*---------------------*/
  $scope.req = { reportFormat: 'PDF', summaryReport: true };
  $scope.data = { cashOnly: false };

  /*------------------------------------------------------------------*/
  /* Watches data.cashOnly for changes and sets the report to submit. */
  /*------------------------------------------------------------------*/
  $scope.$watch('data.cashOnly', function (report) {
    $scope.data.selectedReport = Session.getSessionURL(
      report
        ? '/ConsolidatedCashAccountsReport.aspx'
        : '/ConsolidatedAccountsReport.aspx'
    );
  });

  /*-------------------*/
  /* Load initial data */
  /*-------------------*/
  BooksSvc.getOrganization().then(function (resp) {
    $scope.org = resp.data;
    BusyScreen.setBusy(false);
  });
}